import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash-es/get';
import { Box } from '@components/common';
import {
  Calendar,
  CalendarViewFullItem,
  CalendarViewHalfItem
} from '@components/Calendar';
import CleansActions, { CleansSelectors } from '@redux/CleansRedux';
import useDetectSize from '@hooks/useDetectSize';
import CalendarViewHeader from './CalendarViewHeader';

function CleansCalendarView(props) {
  const {
    cleansList,
    month,
    year,
    loadCleansData,
    currentClean,
    onItemClick,
    currentProperty,
    setProperty
  } = props;
  const isMobile = useDetectSize();
  if (!cleansList) {
    return null;
  }

  const specialItems = cleansList.reduce((acc, item) => {
    const {
      serviceDate,
      serviceMonth,
      serviceType,
      additionalService,
      timeframe,
      timeframeTitle
    } = item;
    if (!acc[serviceMonth]) {
      acc[serviceMonth] = {};
    }

    const transformedItem = {
      date: serviceDate,
      month: serviceMonth,
      serviceType,
      additionalService,
      timeframe,
      timeframeTitle,
      item
    };

    if (!acc[serviceMonth][serviceDate]) {
      acc[serviceMonth][serviceDate] = [transformedItem];
    } else {
      acc[serviceMonth][serviceDate].push(transformedItem);
    }

    return acc;
  }, {});

  const renderHeader = title => {
    return (
      <CalendarViewHeader
        title={title}
        property={currentProperty}
        onSelectProperty={pp => {
          setProperty(pp);
        }}
        onPrev={() => {
          if (month === 1) {
            loadCleansData(12, year - 1);
            return;
          }

          loadCleansData(month - 1, year);
        }}
        onNext={() => {
          if (month === 12) {
            loadCleansData(1, year + 1);
            return;
          }

          loadCleansData(month + 1, year);
        }}
      />
    );
  };

  const renderItem = (specialItem, disabled, selected, isMultple) => {
    const {
      serviceType,
      additionalService,
      timeframe,
      timeframeTitle,
      item
    } = specialItem;
    const { icon: serviceTypeIcon, fullTitle } = serviceType;
    const iconFill = disabled && !selected ? 'darkGray' : undefined;

    if (isMultple) {
      const iconProps = isMobile
        ? { width: 16, height: 16 }
        : { width: 16, height: 16 };
      return (
        <CalendarViewHalfItem
          iconFill={iconFill}
          serviceTypeIcon={serviceTypeIcon}
          timeframeIcon={timeframe}
          timeframeTitle={timeframeTitle}
          fullTitle={fullTitle}
          extraItems={isMobile ? undefined : additionalService}
          iconProps={iconProps}
          onItemClick={() => {
            if (selected) {
              return;
            }
            if (onItemClick) {
              onItemClick(item);
            }
          }}
          disabled={disabled}
        />
      );
    } else {
      const iconProps = isMobile
        ? { width: 24, height: 24 }
        : { width: 16, height: 16 };

      return (
        <CalendarViewFullItem
          iconFill={iconFill}
          serviceTypeIcon={serviceTypeIcon}
          timeframeIcon={timeframe}
          timeframeTitle={timeframeTitle}
          fullTitle={fullTitle}
          extraItems={isMobile ? undefined : additionalService}
          iconProps={iconProps}
          onItemClick={() => {
            if (selected) {
              return;
            }
            if (onItemClick) {
              onItemClick(item);
            }
          }}
          disabled={disabled}
        />
      );
    }
  };

  return (
    <Box display="flex" flexDirection="row">
      <Calendar
        selectedItem={currentClean}
        specialItems={specialItems}
        selectedExtractor={item => {
          if (!item || !currentClean || !currentClean.bookingID) {
            return false;
          }

          const bookingId = get(item, 'item.bookingID');
          return bookingId === currentClean.bookingID;
        }}
        renderSpecialItem={renderItem}
        enableSpecialItemsOnly
        month={month}
        year={year}
        renderHeader={renderHeader}
      />
    </Box>
  );
}

CleansCalendarView.propTypes = {
  currentClean: PropTypes.object,
  cleansList: PropTypes.array,
  month: PropTypes.number,
  year: PropTypes.number,
  currentProperty: PropTypes.object,
  loadCleansData: PropTypes.func,
  onItemClick: PropTypes.func,
  setProperty: PropTypes.func
};

const mapStatesToProps = state => ({
  cleansList: CleansSelectors.selectCleansOfMonth(state),
  month: CleansSelectors.selectCurrentMonth(state),
  year: CleansSelectors.selectCurrentYear(state),
  currentClean: CleansSelectors.selectCurrentClean(state),
  currentProperty: CleansSelectors.selectHomeViewProperty(state)
});

const mapDispatchToProps = dispatch => ({
  loadCleansData: (month, year) =>
    dispatch(CleansActions.setMyCleansOfMonthLoadRequest(month, year)),
  setProperty: property =>
    dispatch(CleansActions.setMyCleansHomeViewProperty(property))
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(CleansCalendarView);
